import { chakra, Text } from '@chakra-ui/react';

export const LabelText = chakra(Text, {
  baseStyle: {
    fontWeight: 'semibold',
    fontFamily: 'heading',
  },
});
